<template>
    <div>
        <div class="floatView">
            <div class="floatList">
                <div class="floatListIcon">
                    <img :src="imgObj.icon_cpsm" alt="">
                </div>
                <div class="floatListText">产品说明</div>
                <div class="cpsmView">
                    <div class="jiantou"></div>
                    产品说明
                    产品说明
                    产品说明
                    产品说明
                    产品说明
                    产品说明
                </div>
            </div>
            <div class="floatList floatListBorder">
                <div class="floatListIcon">
                    <img :src="imgObj.icon_kf" alt="">
                </div>
                <div class="floatListText">客服</div>
                <!--客服码-->
                <div class="hoverShowView">
                    <div class="jiantou"></div>
                    客服码
                </div>
            </div>
            <div class="floatList">
                <div class="floatListIcon">
                    <img :src="imgObj.icon_xcx" alt="">
                </div>
                <div class="floatListText">小程序</div>
                <!--小程序码-->
                <div class="hoverShowView">
                    <div class="jiantou"></div>
                    小程序码
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>

//引入图标
import icon_cpsm from '@/assets/images/floatRight/icon_cpsm.png'
import icon_kf from '@/assets/images/floatRight/icon_kf.png'
import icon_xcx from '@/assets/images/floatRight/icon_xcx.png'

//console.log(ruleList)

export default {
    name:'',
    data(){
        return{
            //图片地址
            imgObj:{
                icon_cpsm,
                icon_kf,
                icon_xcx
            },
        }
    },
    methods:{
    },
    
}
</script>
<style lang="scss" scoped>
.floatView{
    width:80px;
    height:240px;
    background: #EEF8FF;
    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
    position: fixed;
    right:0;
    top:calc(50% - 40px);
    .floatListBorder{
        border-top:1px solid #eeeeee;
        border-bottom:1px solid #eeeeee;
    }
    .floatList:hover .hoverShowView{
        visibility: visible;
        opacity: 1;
        left:-120px;
    }
    .floatList:hover .cpsmView{
        visibility: visible;
        opacity: 1;
        left:-220px;
    }
    .floatList{
        width:80px;
        height:80px;
        box-sizing: border-box;
        cursor:pointer;
        padding-top:15px;
        position: relative;
        .floatListIcon{
            width:26px;
            height:30px;
            margin: 0 auto 0;
            img{
                width:100%;
                height:100%;
            }
        }
        .floatListText{
            width:100%;
            height:14px;
            line-height: 14px;
            text-align: center;
            margin-top:10px;
            font-weight: 400;
            font-size: 14px;
            color: #0F59A4;
        }
        .hoverShowView{
            width:100px;
            height:100px;
            visibility: hidden;
            opacity: 0;
            position: absolute;
            background: #ffffff;
            top:0;
            left:-200px;
            transition: all 0.5s;
            line-height: 100px;
            text-align: center;
            .jiantou{
                width:0;
                height: 0;
                border-top:10px solid transparent;
                border-left:10px solid #ffffff;
                border-bottom:10px solid transparent;
                border-right:10px solid transparent;
                position: absolute;
                top:calc(50% - 10px);
                right:-20px;
            }
        }
        .cpsmView{
            width:200px;
            height:200px;
            visibility: hidden;
            opacity: 0;
            position: absolute;
            background: #ffffff;
            top:-100px;
            left:-300px;
            transition: all 0.15s;

            text-align: center;
            .jiantou{
                width:0;
                height: 0;
                border-top:10px solid transparent;
                border-left:10px solid #ffffff;
                border-bottom:10px solid transparent;
                border-right:10px solid transparent;
                position: absolute;
                top:130px;
                right:-20px;
            }
        }
    }
}
</style>
